import { Ad } from "@models/Ad.model";

export interface ChildGroup {
  key: string;
  label: string;
  ads: Ad[];
}

const LABELS: Record<string, string> = {
  video: "Video",
  image: "Image",
  sms: "SMS",
  email: "Email",
  document: "Document",
  form: "Form",
  container: "Container",
};

export function groupChildren(children: Ad[]): ChildGroup[] {
  const order: string[] = [];
  const map: Record<string, Ad[]> = {};

  const pushLeaf = (key: string, leaf: Ad) => {
    if (!map[key]) {
      map[key] = [];
      order.push(key);
    }
    map[key].push(leaf);
  };

  for (const child of children) {
    if (child.type === "container") {
      const key = (child.subtype ?? child.type ?? "container").toString();
      for (const leaf of child.children ?? []) {
        pushLeaf(key, leaf);
      }
    } else {
      const key = (child.type ?? "container").toString();
      pushLeaf(key, child);
    }
  }

  return order.map((key) => ({
    key,
    label: LABELS[key] ?? key,
    ads: map[key],
  }));
}
